import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'signedNumber',
})
export class SignedNumberPipe implements PipeTransform {
  transform(value: number): string {
    if (!value) return '';

    const absFormatted = Math.abs(value).toLocaleString();

    if (value > 0) {
      return '+' + absFormatted;
    }

    if (value < 0) {
      return '-' + absFormatted;
    }

    return '0';
  }
}
